/**
  * TODO
  * @namespace v3sWbtPlayerApp:tools:tree
  */

/**
 * @class directive_v3sTreeTool
 * @memberOf v3sWbtPlayerApp:tools:tree
 * @description
 * TODO
 */
angular.module('v3sWbtPlayerApp').directive('v3sTreeTool', ["v3sWbtDataService", "v3sNavigationService", function (v3sWbtDataService, v3sNavigationService) {

    return {
        restrict: 'E',
        scope: {
            currentItem: '=',
            wbt: '='
        },
        link: function (scope, element) {

            var updateTree = function () {
                if (element[0].offsetParent !== null) { //aktualisiere falls Baum sichtbar
                    element[0].innerHTML = createList(scope.wbt);
                }
            };

            var createList = function (node) {
                var html, children;
                var active = true;

                if (!!node && !!node.getChildren) {
                    children = node.getChildren();
                }

                if (!!node.parent) {
                    var href = v3sNavigationService.getHref(v3sNavigationService.getPageState(node));

                    active = scope.currentItem.isTreeParent(node);
                    var cssClass = active ? "current-item" : "";

                    if (!href || node.isLocked()) {
                        href = 'javascript:void(0)';
                        cssClass += ' locked';
                    }

                    html = '<a id="' + node.id + '-tree-item" class="' + cssClass + '" href="' + href + '"' + '>';

                    if (!!children && children.length > 0) {
                        html += '<i class="v3s-icon icon-tree"></i>';
                    }

                    html += '<span><span class="v3sLabel" data-title="' + node.title
                        + '" data-placement="top auto" bs-tooltip data-container="#feedbacks">' +
                        node.title + '</span>';

                    if (!node.hiddenItem) {
                        var status = 'v3s-icon v3s-icon-state ';
                        status += node.getStatus().replace(/\s+/g, '-') + " ";
                        status += node.getExerciseStatus();

                        if (!node.isTrackable()) {
                            status += " not-trackable";
                        }

                        if (!!node.sco && !v3sWbtDataService.isScoStatusLoaded(node.id)) {
                            status += " no-data-loaded";
                        }

                        html += '<i class="' + status + '"></i>';
                    }

                    html += '</span></a>';
                } else {
                    html = '';
                }

                if (!!children && active) {
                    html += '<ul id="' + node.id + '-tree-children" class="open">';
                    angular.forEach(children, function (child) {
                        if ((child.isVisible() || scope.currentItem == child || scope.currentItem.isTreeParent(child)) && (!child.treeParent || children != node.children)) {
                            html += '<li>';
                            html += createList(child);
                            html += '</li>';
                        }
                    });
                    html += '</ul>';
                }

                return html;
            };

            //aktualisiere beim Aktualisieren einer Seite
            v3sWbtDataService.getWbt().subscribePageChanged(scope, updateTree);

            //aktualisiere beim Seitenwechsel
            scope.$watch(function () {
                if (!!scope.currentItem) {
                    return scope.currentItem.id;
                }
            }, function () {
                updateTree();
            });
        }
    };
}]);


